<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-input v-model="query.businessCode" placeholder="Business Code" clearable></el-input>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-input v-model="query.brandName" placeholder="Brand Name" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button type="primary" icon="search" @click="onSubmit">Query</el-button>
                    <el-button type="primary" v-if="authRulesFun('brand/save')" @click.native="handleForm(null,null)">Add</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;">
            <el-table v-loading="loading"  :data="list" style="width: 100%;">
                <el-table-column label="No."  type="index" width="50"> </el-table-column>
                <el-table-column label="Business Code" prop="businessCode" width="200"></el-table-column>
                <el-table-column label="Brand Name" prop="brandName" width="200"> </el-table-column>
                <el-table-column label="Creator" prop="createUser" width="100"> </el-table-column>
                <el-table-column label="Updater" prop="updateUser" width="100"> </el-table-column>
                <el-table-column label="Last Update Time" with="200" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <i class="el-icon-time" v-if="scope.row.updateTime"></i>
                        <span>{{ scope.row.updateTime | formatDateStr('yyyy-MM-dd hh:mm:ss') }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Operation" width="400" v-if="authRulesFun('brand/edit')||authRulesFun('prefixcode/index')||authRulesFun('brand/client/index')||authRulesFun('brand/delete')">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="authRulesFun('brand/edit')" @click.native="handleForm(scope.$index, scope.row)">Edit</el-button>
                        <el-button type="text" size="small" v-if="authRulesFun('prefixcode/index')" @click.native="deliVisibleFun(scope.$index, scope.row)">Prefix Code</el-button>
                        <el-button type="text" size="small" v-if="authRulesFun('brand/client/index')" @click.native="formDataVoucherFun(scope.row);">Client Credentials</el-button>
                        <el-button type="text" size="small" v-if="authRulesFun('brand/open/data')" @click.native="createTable(scope.$index, scope.row)">Create Table</el-button>
                        <el-button type="text" size="small" v-if="authRulesFun('brand/delete')" @click.native="handleDel(scope.$index, scope.row)">Delete</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>

        <el-pagination
            :page-size="query.limit"
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :total="total">
        </el-pagination>

        <!--表单-->
        <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="60%" top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="Business Code" prop="businessCode">
                    <el-input v-model.trim="formData.businessCode" maxlength="60" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Brand Name" prop="brandName">
                    <el-input  v-model="formData.brandName" maxlength="60" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">Cancel</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">Save</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="'Prefix Code'" :visible.sync="deliVisible"  width="85%" top="5vh">
            <el-form :model="prefixForm"  ref="prefixForm" label-width="120px" class="demo-dynamic">
                <el-form-item v-for="(domain, index) in prefixForm.prefix" :label="'Prefix Code ' + (index+1)" :key="domain.key" :prop="'prefix.' + index + '.code'" :rules="rulesList">
                    <el-input v-model.trim="domain.code" maxlength="60" style="width:calc(100% - 130px)"></el-input>
                    <el-button v-if="index!=0&&authRulesFun('prefixcode/save')" style="width:100px;margin-left:20px;" @click.prevent="removeDomain(domain)">Delete</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-if="authRulesFun('prefixcode/save')"  @click.native="submit()">Save</el-button>
                    <el-button v-if="authRulesFun('prefixcode/save')" @click="addDomain">New Prefix Code</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 生成凭证 -->
        <el-dialog :title="'Client Credentials'" :visible.sync="voucherLoading"  width="70%" top="5vh">
            <el-form :model="formDataVoucher" label-width="120px"  ref="dataForm"     >
                <el-form-item label="" label-width="0px" >
                     <h3 style="text-align: center;">Please Copy The Client Credentials To ID Cloud API Credentials</h3>
                </el-form-item >
                <el-form-item label="Client ID" style="font-weight: bold;">
                     <span style="width:calc( 100% - 240px);display: inline-block;border:solid 1px #dedede;border-radius:5px;padding:0 10px;    font-weight: initial;">{{formDataVoucher.clientId}}</span>
                     <el-button type="primary" style="margin-left:20px;" icon="el-icon-document-copy" v-clipboard:copy="formDataVoucher.clientId" v-clipboard:success="onCopy">Copy</el-button>
                </el-form-item >
                <el-form-item label="Client Secret" style="font-weight: bold;">
                    <span style="width:calc( 100% - 240px);display: inline-block;border:solid 1px #dedede;border-radius:5px;padding:0 10px;    font-weight: initial;">{{formDataVoucher.clientSecret}}</span>
                     <el-button type="primary" style="margin-left:20px;" icon="el-icon-document-copy" v-clipboard:copy="formDataVoucher.clientSecret" v-clipboard:success="onCopy">Copy</el-button>
                </el-form-item>
                <el-form-item label="API Key" style="font-weight: bold;">
                    <span style="width:calc( 100% - 240px);display: inline-block;border:solid 1px #dedede;border-radius:5px;padding:0 10px;    font-weight: initial;">{{formDataVoucher.apiKey}}</span>
                     <el-button type="primary" style="margin-left:20px;" icon="el-icon-document-copy" v-clipboard:copy="formDataVoucher.apiKey" v-clipboard:success="onCopy">Copy</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <!-- <el-button @click.native="formVisible = false">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button> -->
            </div>
        </el-dialog>
    </div>

</template>

<script>
import {
    brandList,
    brandSave,
    brandDelete,
    openData,
    savePrefixCode,
    queryPrefixCode,
    queryClient
} from "../../../api/auth/brand";

const formJson = {
    id: "",
    businessCode: ""
};
export default {

    data() {
         const isNumAZ = (rule, value, callback) => {
            const age= /^[0-9a-zA-Z]*$/
            if (!age.test(value)) {
                callback(new Error('Only numbers and letters can be entered'))
            }else{
                callback()
            }
        }
        return {
            rulesList:[
                { required: true,message: 'Prefix code cannot be empty', trigger: 'blur' },
                { validator: isNumAZ, trigger: 'blur'},
                { max:60,message: 'Max 60',trigger: 'blur'}
            ],
            authRules: this.$store.state.admin.authRules,
            query: {
                page: 1,
                limit: 20,
                businessCode: ""
            },
            list: [],
            total: 0,
            loading: true,
            index: null,
            formName: null,
            formMap: {
                Add: "Add",
                Edit: "Edit"
            },
            formLoading: false,
            deliVisible: false,
            formVisible: false,
            voucherLoading: false,
            formData: formJson,
            formDataVoucher: {

            },
            prefixDataMap: {},
            prefixDataMapDelete: [],
            prefixForm: {
                prefix: [
                    { code: ''}
                ],
            },
            formRules: {
                businessCode: [
                    { required: true, message: "Please enter business code", trigger: "blur" }
                ],
                brandName:[
                    { required: true, message: "Please enter brand name", trigger: "blur" }
                ]
            },
            addRules: {

            },
            editRules: {

            },
            deleteLoading: false
        };
    },
    methods: {
        authRulesFun(url){

//            if(url=='brand/open/data'&&this.authRules.length==1){
//                return true
//            }else if(url=='brand/open/data'){
//                return false
//            }
            if(this.authRules.length==1 ){
                return true
            }
            var status = false
            for(var a=0;a<this.authRules.length;a++){
                if(this.authRules[a]==url){
                    status = true
                    break;
                }else {
                    status = false
                }
            }
            return status
        },
        formDataVoucherFun(row){
            queryClient({'brandId':row.id}).then(response => {
               this.voucherLoading = true
               this.formDataVoucher = response.data
            }).catch(() => {

            });
        },
        onCopy() {
            this.$message.success('Successfully');
        },
        submit() {
            this.$refs["prefixForm"].validate(valid => {
                if(valid){
                    var data={
                        "insertRecords" : [],//[{code:"1"},{code:"2"}],
                        "removeRecords" : this.prefixDataMapDelete,//[{id:1},{id:2}],
                        "updateRecords" : [],//[{id:1,code:"1"},{id:2,code:"1"}],
                        "brandId": this.detailed.id
                    }
                    for(var a=0;a<this.prefixForm.prefix.length;a++){
                        if(this.prefixForm.prefix[a].id){
                            if(this.prefixDataMap[this.prefixForm.prefix[a].id]){
                                if(this.prefixDataMap[this.prefixForm.prefix[a].id].code != this.prefixForm.prefix[a].code){
                                    data.updateRecords.push({id:this.prefixForm.prefix[a].id,code:this.prefixForm.prefix[a].code})
                                }else if(this.prefixDataMap[this.prefixForm.prefix[a].id].code == this.prefixForm.prefix[a].code){
                                }else{
                                    this.prefixDataMap[this.prefixForm.prefix[a].id].delete = true
                                }
                            }
                        }else{ //add
                            data.insertRecords.push({code:this.prefixForm.prefix[a].code})
                        }
                    }
                    savePrefixCode(data).then(response => {
                       if(response.code){
                           this.$message.error(response.message);
                           return;
                       }
                       this.$message.success("Successfully");
                       this.deliVisible = false
                    }).catch((e) => {
                        this.$message.error(e.message);
                    });
                }
            })
        },
        addDomain() {
            this.prefixForm.prefix.push({brandId:'',code: "",id:''});
        },
        removeDomain(item) {
            var index = this.prefixForm.prefix.indexOf(item)
            if (index !== -1) {
                if(this.prefixForm.prefix[index].id){
                    this.prefixDataMapDelete.push({id:this.prefixForm.prefix[index].id})
                }
                this.prefixForm.prefix.splice(index, 1)
            }
        },
        deliVisibleFun(index, row) {
            this.detailed = row;
            this.prefixDataMapDelete = []
            queryPrefixCode({'brandId':row.id}).then(response => {
                for(var a=0;a<response.data.length;a++){
                    this.prefixDataMap[response.data[a].id] = JSON.parse(JSON.stringify(response.data[a]))
                }
                this.prefixForm={
                    prefix: response.data.length==0?[{ code: ''}]:response.data,
                }
            }).catch(() => {

            });
            this.deliVisible = true;
        },
        onReset() {
            this.$router.push({
                path: ""
            });
            this.query = {
                // username: "",
                // status: "",
                page: 1,
                limit: 20,
                businessCode: ""
            };
            this.getList();
        },
        onSubmit() {
            this.$router.push({
                path: "",
                query: this.query
            });
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        getList() {
            this.loading = true;
            brandList(this.query)
                .then(response => {
                    this.loading = false;
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.list = response.data.list || [];
                    this.total = response.data.total || 0;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                    // this.roles = [];
                });
        },
        // hide form
        hideForm() {
            // updata value
            this.formVisible = !this.formVisible;
            return true;
        },
        // updata form
        resetForm() {
            if (this.$refs["dataForm"]) {
                // clean form
                this.$refs["dataForm"].clearValidate();
                // updata form
                this.$refs["dataForm"].resetFields();
            }
        },
        // show form
        handleForm(index, row) {
            this.formVisible = true;
            this.formData = JSON.parse(JSON.stringify(formJson));
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            // this.formData.password = "";
            // this.formData.checkPassword = "";
            this.formName = "Add";
            // this.formRules = this.addRules;
            if (index != null) {
                this.index = index;
                this.formName = "Edit";
                // this.formRules = this.editRules;
            }
        },
        formSubmit() {
            this.$refs["dataForm"].validate(id => {
                if (id) {
                    this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    brandSave(data, this.formName).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("Successfully");
                        this.formVisible = false;
                        this.onSubmit();
                    });
                }
            });
        },
        // delete
        handleDel(index, row) {
            if (row.id) {
                this.$confirm("Are you sure to delete this record?", "Tips", {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: "warning"
                })
                    .then(() => {
                        let para = { id: row.id };
                        this.deleteLoading = true;
                        brandDelete(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("Successfully");
                                // 刷新数据
                                this.list.splice(index, 1);
                                this.total--;
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
//                        this.$message.error("Cancel");
                    });
            }
        },
        // Create table
        createTable(index, row) {
            if (row.id) {
                this.$confirm("Are you sure you want to create a table?If the table has been created,it will not be created again.", "Tips", {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    type: "warning"
                })
                    .then(() => {
                        let para = { brandId: row.id };
                        this.deleteLoading = true;
                        openData(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("Successfully");
                                // updata form
                                // this.list.splice(index, 1);
                                // this.total--;
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
//                        this.$message.error("Cancel");
                    });
            }
        }
    },
    mounted() {},
    created() {
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.limit = parseInt(this.query.limit);
        this.getList();
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
